const PlaceholderManagementType = {
  CATEGORY1: 'CATEGORY1',
  CATEGORY2: 'CATEGORY2',
  BRANDS: 'BRANDS',
  SEASONS: 'SEASONS',
};

export default PlaceholderManagementType;
